import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

export type StageStepState = 'completed' | 'current' | 'upcoming' | 'terminal';

export interface StageStepView {
  name: string;
  state: StageStepState;
}

@Component({
  selector: 'app-lead-stage-stepper',
  templateUrl: './lead-stage-stepper.component.html',
  styleUrls: ['./lead-stage-stepper.component.scss'],
})
export class LeadStageStepperComponent implements OnChanges {
  @Input() stages: { stage_name: string; probability?: number }[] = [];
  @Input() currentStatus = '';

  steps: StageStepView[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['stages'] || changes['currentStatus']) {
      this.buildSteps();
    }
  }

  private buildSteps(): void {
    const list = [...(this.stages || [])].filter((s) => s?.stage_name);
    if (!list.length) {
      this.steps = [];
      return;
    }

    const currentNorm = this.norm(this.currentStatus);
    let currentIndex = list.findIndex(
      (s) => this.norm(s.stage_name) === currentNorm
    );
    if (currentIndex < 0 && this.currentStatus) {
      currentIndex = list.findIndex((s) =>
        this.norm(s.stage_name).includes(currentNorm)
      );
    }
    if (currentIndex < 0) {
      currentIndex = 0;
    }

    this.steps = list.map((s, i) => ({
      name: s.stage_name,
      state: this.resolveState(s.stage_name, i, currentIndex),
    }));
  }

  private resolveState(
    stageName: string,
    index: number,
    currentIndex: number
  ): StageStepState {
    if (index < currentIndex) {
      return 'completed';
    }
    if (index > currentIndex) {
      return this.isTerminalStage(stageName) ? 'terminal' : 'upcoming';
    }
    return this.isTerminalStage(stageName) ? 'terminal' : 'current';
  }

  private isTerminalStage(name: string): boolean {
    return /unqualified|disqualified|closed\s*lost|lost|rejected|dead/i.test(
      name || ''
    );
  }

  private norm(v: string): string {
    return (v || '').trim().toLowerCase();
  }
}
